import { dateComparator, SortStateComparator } from "../utils/sort";
import { Event } from "./Events";

export const eventStartDateComparator: SortStateComparator<Event | undefined> = (a, b) =>
  dateComparator(a?.eventStart, b?.eventStart);
